<template>
  <el-dialog class="myCheck"
             :visible.sync="myVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="1300px"
             title="我的考勤">
    <div class="mySearchCont">
      <el-form :model="searchForm"
               ref="searchForm"
               label-width="60px"
               :inline="true">
        <el-form-item label="状态"
                      size="small">
          <el-select v-model="searchForm.status"
                     size="small"
                     placeholder="请选择状态">
            <el-option v-for="item in statusList"
                       :key="item.status"
                       :label="item.name"
                       :value="item.status"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年"
                      size="small">
          <el-date-picker v-model="searchForm.year"
                          type="year"
                          placeholder="选择年"
                          :value-format="yyyy"
                          :format="yyyy"
                          size="small">
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left:10px;"
                      size="small">
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="profileAttendance">
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="myCheckTable">
      <el-table border
                :data="tableData"
                highlight-current-row>
        <el-table-column label="年月"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.year}}-{{scope.row.month}}
          </template>
        </el-table-column>
        <el-table-column label="应出勤天数"
                         property="need_work_days"
                         align="center"
                         width="100">
        </el-table-column>
        <el-table-column label="实出勤天数"
                         property="real_work_days"
                         align="center"
                         width="100">
        </el-table-column>
        <el-table-column label="缺勤天数"
                         property="miss_work_days"
                         align="center">
        </el-table-column>
        <el-table-column label="迟到次数"
                         align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        :content='`迟到分钟：${scope.row.late_minute}分钟`'
                        placement="top">
              <div>{{scope.row.late_count}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="早退次数"
                         align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        :content='`早退分钟：${scope.row.early_minute}分钟`'
                        placement="top">
              <div>{{scope.row.early_count}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="加班次数"
                         property="over_hour"
                         align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        :content='`加班小时：${scope.row.over_hour}分钟`'
                        placement="top">
              <div>{{scope.row.over_count}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="状态"
                         property="status_cn"
                         align="center">
          <template slot-scope="scope">
            <div :class="scope.row.status==2?'redText':''">
              {{scope.row.status_cn}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="审核状态"
                         property="check_status"
                         align="center">
          <template slot-scope="scope">
            <div :class="scope.row.check_status=='未审核'?'redText':''">
              {{scope.row.check_status?scope.row.check_status:'--'}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="审核人"
                         property="checker"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.checker?scope.row.checker:'--'}}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         width="200">
          <template slot-scope="scope">
            <div class="color-blue">
              <el-button type="text"
                         size="small"
                         class="color-blue"
                         @click="detail(scope.row)">详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer"
            class="dialog-footer">
        <pagination :total="total"
                    :page.sync="page"
                    :perPage.sync="perPage"></pagination>
      </span>
    </div>
    <reportDetail :detailItem.sync="detailItem"
                  :reportDetailVisible.sync='reportDetailVisible'></reportDetail>
  </el-dialog>
</template>
<script>
import pagination from "@/comon/components/pagination"
import reportDetail from "../../pages/staffAdmin/attendanceAdmin/reportDetail"
import * as oaApi from "@/http/oaApi.js";
export default {
  data () {
    return {
      tableData: [],
      remark: "",
      statusList: [
        { name: '请选择', status: '' },
        { name: '正常', status: 1 },
        { name: '异常', status: 2 }
      ],
      searchForm: {
        status: '',
        year: ''
      },
      page: '1',
      perPage: '10',
      total: '',


      detailItem: '',
      reportDetailVisible: false,
    }
  },
  components: {
    pagination: pagination,
    reportDetail: reportDetail
  },
  methods: {
    closeDialog () {
      this.searchForm = {}
      this.tableData = []
      this.page = '1'
      this.perPage = '10'
      this.total = ''
      this.$emit('update:myVisible', false)
    },
    /**
     * 获取table
     */
    profileAttendance () {
      oaApi.profileAttendance({
        status: this.searchForm.status,
        year: this.searchForm.year,
        'per-page': this.perPage,
        page: this.page,
      }, 'get').then(res => {
        if (res) {
          this.tableData = res.data
          this.total = res.total
        }
      })
    },
    /**
     * 点击个人详情
     */
    detail (row) {
      this.detailItem = row
      this.reportDetailVisible = true
    },
  },
  watch: {
    myVisible: {
      handler (newValue) {
        this.profileAttendance()
      },
      deep: true,
      immediate: false
    },

    perPage: {
      handler (newValue) {
        this.perPage = newValue;
        this.profileAttendance()
      },
      deep: true,
      immediate: false
    },
    page: {
      handler (newValue) {
        this.page = newValue;
        this.profileAttendance()
      },
      deep: true,
      immediate: false
    }
  },
  props: {
    myVisible: 'Boolean'
  },

}
</script>
<style lang="scss">
.myCheck {
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }
    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
    .el-dialog__body {
        padding: 10px 20px;
    }
    .myCheckTable {
        margin-top: 10px;
        height: 100%;
        .redText {
            color: red;
        }
    }
    .mySearchCont {
        display: flex;
        width: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        align-items: center;
    }
}
</style>